import axiosInstance from '../../../Helpers/api_helper';

// Function to compute the start and end date of the current year
const getYearStartEndDates = (): { startDate: string; endDate: string } => {
  const currentYear = new Date().getFullYear();
  const startDate = `${currentYear}-01-01`;
  const endDate = `${currentYear}-12-31`;
  return { startDate, endDate };
};

// Function to get candidate results
export const getCandidateResults = async (
  startDate?: string,
  endDate?: string,
  pageNo: number = 1,
  pageSize: number = 20
): Promise<any> => {
  try {
    // Compute dates if not provided
    const { startDate: defaultStartDate, endDate: defaultEndDate } = getYearStartEndDates();
    const finalStartDate = startDate || defaultStartDate;
    const finalEndDate = endDate || defaultEndDate;

    // Retrieve username from local storage
    const storedUserData = localStorage.getItem('userData');
    const username = storedUserData ? JSON.parse(storedUserData).email : '';

    // Log the parameters for debugging
    console.log('Request Parameters:', {
      Startdate: finalStartDate,
      Enddate: finalEndDate,
      Page_no: pageNo,
      Page_size: pageSize,
      Username: username,
    });

    const response = await axiosInstance.get(
      `api/v1/speedexams/candidate-results`,
      {
        params: {
          Startdate: finalStartDate,
          Enddate: finalEndDate,
          Page_no: pageNo,
          Page_size: pageSize,
          Username: username,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Error getting candidate results:', error.message);
    throw error;
  }
};
